import { setCheckedAreas, setCompanyId, setOrgCode, setStaffId } from 'data/storage';
import { RootState } from 'model';
import { setMeetingInfo } from 'model/meeting';
import { getCompanyList } from 'model/user';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CompanyDisplayConfig } from 'type/company';
import BaseComponent from './BaseComponent';
import { setPersonConfig } from './model';

// 容器组件
const Switch: React.FC = () => {
  const companyList = useSelector((state: RootState) => state.user.companyList);

  useEffect(() => {
    dispatch(getCompanyList());
  }, []);

  const dispatch = useDispatch();

  const onSubmit = (staffId: string) => {
    const company = companyList.find((c) => c.staffId === staffId);
    if (!company) return;

    const companyInfo: CompanyDisplayConfig = {
      companyName: company.companyName ?? company.shortName,
      displayType: 3,
      jobName: company.jobTitle,
      staffId
    };
    setCompanyId(company.companyId);
    setOrgCode(company.orgCode);
    setStaffId(staffId);
    setCheckedAreas('');

    dispatch(setMeetingInfo(null));
    dispatch(setPersonConfig(companyInfo));
  };

  return <BaseComponent companyList={companyList} onSubmit={onSubmit} />;
};

export default Switch;
